export interface IncubatorCreateLineSettingsPayload {
    coef_changing: number
    consider_personal_limits: number
    delay_for_bets_time: number
    hide_creator: number
}

export interface IncubatorCreateLineSettingsInput {
    coefChanging: number
    considerPersonalLimits: boolean
    delayForBetsTime: number
    hideNickname: boolean
}

export const incubatorCreateLineSettingsPayload = (
    input: IncubatorCreateLineSettingsInput
): IncubatorCreateLineSettingsPayload => ({
    coef_changing: input.coefChanging,
    consider_personal_limits: Number(input.considerPersonalLimits),
    delay_for_bets_time: input.delayForBetsTime,
    hide_creator: Number(input.hideNickname)
});
